/**
 * Tipos de aviso da central de avisos. O texto de cada tipo da base fica nos arquivos de tradução
 * (notifications.kinds.<tipo com _ no lugar do ponto>); o de um módulo, nos arquivos de tradução
 * do próprio módulo (<módulo>.notifications.<resto do tipo>, ADR 0131).
 */
export const NOTIFICATION_KINDS = [
  // Aviso de exemplo: quem recebeu um perfil de acesso. Cada módulo novo acrescenta os seus.
  'iam.role_granted',
] as const;
/** Um tipo da base ou de um módulo (`<módulo>.<aviso>`, com o texto nos arquivos do módulo). */
export type NotificationKind = (typeof NOTIFICATION_KINDS)[number] | `${string}.${string}`;

/** Chave do texto do aviso nos arquivos de tradução. */
export function notificationTextKey(kind: string): string {
  if ((NOTIFICATION_KINDS as readonly string[]).includes(kind)) {
    return `notifications.kinds.${kind.replace('.', '_')}`;
  }
  const dot = kind.indexOf('.');
  return dot > 0
    ? `${kind.slice(0, dot)}.notifications.${kind.slice(dot + 1)}`
    : `notifications.kinds.${kind}`;
}
